import moment, { Moment } from "moment";
import { isEmptyValue } from "../common";
import { TCustomFormatMap } from "./_type";
import { DATE_FORMATE_MAP, EXTRA_FORMATS } from "./contant";


/**
 * @description: 获取当周第一天
 * @param {Moment} val 值
 * @param {string} emptyValue 为空时默认展示
 * @return {string}
 */
const  getCurrentWeekFirstDay = (val: Moment, emptyValue?: string): string => {
  const value = val?.startOf('isoWeek');
  return value?.format('YYYY-MM-DD') || (emptyValue ?? '-');
};

export const CUSTOM_FORMAT_MAP: TCustomFormatMap = {
  firstWeekDay: getCurrentWeekFirstDay
};

// 判断是否是日期格式的字符串
export const isMomentParsableString = (val: string, extraFormats?: string []): boolean => {
  if (typeof val !== 'string') return false;
  const s = val?.trim();
  if (!s) return false;
  // 额外支持常见的紧凑格式（严格模式），如 YYYYMMDD、YYYYMMDDHHmm
  return (
    moment(s, extraFormats || EXTRA_FORMATS, true).isValid() ||
    moment(s, moment.ISO_8601, true).isValid() ||
    moment(s, moment.RFC_2822, true).isValid()
  );
};

/**
 * @description: 日期格式化，当前经分共有以下五种类型：
 * 'YYYY-MM', 'YYYY-MM-DD', 'MM-DD', 'HH:mm', 'first-week-day'（当周第一天）
 * @param {string} val 值
 * @param {string} formatRule 格式化规则
 * @param {string} emptyValue 为空时默认展示
 * @return {string}
 */
const dateTimeFormat = ( val: string, formatRule: string, emptyValue?: string, otherConfig?: {isStrictMode: boolean; extraFormats?: string[]; }): string => {
  const { isStrictMode, extraFormats } = otherConfig || {};
  // 如果传入空字符串，则直接使用空字符串，如果不传，则用经分的默认'-'，所以可直接使用??
  if (isEmptyValue(val)) {
    return emptyValue ?? '-';
  }
  try {
    if(isStrictMode && !isMomentParsableString(val, extraFormats)) {
      return val;
    }
    const value = moment(val);
    // 如果不是有效的日期，则返回原值
    if (!(value?.isValid())) {
      console.log('dateTimeFormat Invalid date');
      return val;
    }
    // 自定义格式化
    if(CUSTOM_FORMAT_MAP[formatRule]) {
      return CUSTOM_FORMAT_MAP[formatRule]?.(value);
    }
    // 快捷格式化，兜底格式化
    return value?.format(DATE_FORMATE_MAP?.[formatRule] || formatRule);
  } catch (error) {
    console.log('dateTimeFormat error', error);
    return val;
  }
};

export  default dateTimeFormat;